<script>
import Metadata from '@/components/Metadata.vue'
import RejectEvent from '@/components/RejectEvent.vue'
import InfoOverlay from '@/components/Infooverlay.vue'

export default {
  props: {
    metadata: Object,
    selected: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    Metadata,
    RejectEvent,
    InfoOverlay
  }
}
</script>

<template>
  <header class="controls">
    <div class="controls-title">
      <Popover class="mr-4" :options="{ placement: 'bottom-start' }">
        <template v-slot:default="{ isVisible }">
          <button
            :class="[
              'button',
              'button--icon',
              't-muted',
              { 'is-active': isVisible }
            ]"
          >
            <svg class="icon icon--xl">
              <use xlink:href="#question"></use>
            </svg>
          </button>
        </template>
        <template v-slot:content>
          <InfoOverlay />
        </template>
      </Popover>
      <h1 class="t3 t-bold">
        Choose the best after image from this waste event
      </h1>

      <Popover class="ml-1" v-if="metadata" :options="{ placement: 'bottom' }">
        <template v-slot:default="{ isVisible }">
          <button
            :class="[
              'button',
              'button--icon',
              'px-1',
              'py-1',
              { 'is-active': isVisible }
            ]"
            v-test="'metadata-popup'"
          >
            <svg class="icon icon--lg"><use xlink:href="#info"></use></svg>
          </button>
        </template>
        <template v-slot:content>
          <template v-for="(value, name) in metadata">
            <Metadata :name="name" :value="value" :key="name" />
          </template>
        </template>
      </Popover>
    </div>

    <div class="controls-actions">
      <Popover :options="{ placement: 'bottom-end' }">
        <button class="button button--danger" v-test="'reject'">
          Reject event
          <svg class="icon icon--lg">
            <use xlink:href="#chevron-down"></use>
          </svg>
        </button>
        <template v-slot:content="{ hide }">
          <RejectEvent
            @selectReason="
              $emit('reject', $event)
              hide()
            "
          />
        </template>
      </Popover>
      <span>or</span>
      <button
        :disabled="selected === null"
        @click="$emit('submit', $event)"
        class="button button--primary"
        v-test="'submit'"
      >
        Submit choice
      </button>
    </div>
  </header>
</template>

<style lang="scss">
@import '@/styles/_functions.scss';
@import '@/styles/_settings.scss';

.controls {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 20px 0;
}

.controls-title {
  display: flex;
  align-items: center;
}

.controls-actions {
  display: flex;
  align-items: center;
  margin-right: 30px;

  span {
    display: block;
    padding: 0 15px;
    color: $gray-600;
  }
}
</style>
